import { dateLocale } from "../i18n/dateLocale";

/**
 * A blog timestamp as a calendar date in the reader's language; `""` for a missing or
 * unparsable value.
 *
 * @param {string | null | undefined} iso ISO-8601 timestamp.
 * @param {string} lang product language (fr | en | es).
 * @param {"short" | "long"} [month] month style: abbreviated for tables, spelled out for articles.
 */
export function formatBlogDate(iso, lang, month = "short") {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(dateLocale(lang), { year: "numeric", month, day: "numeric" });
}
